"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BodyRow = BodyRow;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireWildcard(require("react"));
var _bodyRowModule = _interopRequireDefault(require("./body-row.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _noop = require("../../../utils/noop");
function BodyRow(_ref) {
  var row = _ref.row,
    onClick = _ref.onClick,
    children = _ref.children,
    testId = _ref['data-testid'],
    _ref$onMouseEnter = _ref.onMouseEnter,
    onMouseEnter = _ref$onMouseEnter === void 0 ? _noop.noop : _ref$onMouseEnter,
    _ref$onMouseLeave = _ref.onMouseLeave,
    onMouseLeave = _ref$onMouseLeave === void 0 ? _noop.noop : _ref$onMouseLeave,
    className = _ref.className;
  var handleClick = (0, _react.useCallback)(function () {
    row && onClick && onClick(row);
  }, [onClick, row]);
  return /*#__PURE__*/_react.default.createElement("tr", {
    "data-testid": testId,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: (0, _classnames.default)(_bodyRowModule.default['body-row'], className, (0, _defineProperty2.default)({}, _bodyRowModule.default['body-row--with-pointer'], row && onClick)),
    onClick: handleClick
  }, children);
}